import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetNotificationSubscriptionByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/GetNotificationSubscriptionByDossierIdController.php
* @route '/api/fetch-notification-subscriptions/{id}'
*/
const GetNotificationSubscriptionByDossierIdController = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNotificationSubscriptionByDossierIdController.url(args, options),
    method: 'get',
})

GetNotificationSubscriptionByDossierIdController.definition = {
    methods: ["get","head"],
    url: '/api/fetch-notification-subscriptions/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetNotificationSubscriptionByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/GetNotificationSubscriptionByDossierIdController.php
* @route '/api/fetch-notification-subscriptions/{id}'
*/
GetNotificationSubscriptionByDossierIdController.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return GetNotificationSubscriptionByDossierIdController.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetNotificationSubscriptionByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/GetNotificationSubscriptionByDossierIdController.php
* @route '/api/fetch-notification-subscriptions/{id}'
*/
GetNotificationSubscriptionByDossierIdController.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNotificationSubscriptionByDossierIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetNotificationSubscriptionByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/GetNotificationSubscriptionByDossierIdController.php
* @route '/api/fetch-notification-subscriptions/{id}'
*/
GetNotificationSubscriptionByDossierIdController.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetNotificationSubscriptionByDossierIdController.url(args, options),
    method: 'head',
})

export default GetNotificationSubscriptionByDossierIdController